export default "__VITE_ASSET__RAZhBXF6__"